import { api } from '../../services/api'

const state = () => ({
  items: [],
  loading: false,
  error: null,
  totalAgreements: 0,
  totalSales: '₹0'
})

const getters = {
  byType: (s) => (type) => s.items.filter(a => a.type === type)
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items
  },
  SET_LOADING(state, val) {
    state.loading = val
  },
  SET_ERROR(state, val) {
    state.error = val
  },
  RECOMPUTE(state) {
    state.totalAgreements = state.items.length
    const total = state.items.reduce((sum, a) => {
      return sum + (parseFloat(a.amount || a.sale_amount || a.purchase_amount) || 0)
    }, 0)
    state.totalSales = `₹${total.toFixed(0)}`
  },
  ADD_ITEM(state, item) {
    state.items.unshift(item)
  },
  UPDATE_ITEM(state, item) {
    const i = state.items.findIndex(a => String(a.id) === String(item.id))
    if (i !== -1) state.items.splice(i, 1, item)
  },
  REMOVE_ITEM(state, id) {
    state.items = state.items.filter(a => String(a.id) !== String(id))
  }
}

const actions = {
  async listAgreements({ commit }) {
    console.log('🚀 [listAgreements] START')

    commit('SET_LOADING', true)
    commit('SET_ERROR', null)

    try {
      console.log('📡 Calling APIs...')

      const [salesRes, purchaseRes, purchaseRecordsRes] = await Promise.all([
        api.get('agreements')
          .then(res => {
            console.log('✅ Sales API Response:', res)
            return res
          })
          .catch(err => {
            console.warn('⚠️ Sales API Failed:', err)
            return { data: { success: true, data: [] } }
          }),

        api.get('purchase-agreements')
          .then(res => {
            console.log('✅ Purchase API Response:', res)
            return res
          })
          .catch(err => {
            console.warn('⚠️ Purchase API Failed:', err)
            return { data: { success: true, data: [] } }
          }),

        api.get('admin/purchase-records')
          .then(res => {
            console.log('✅ Purchase Records API Response:', res)
            return res
          })
          .catch(err => {
            console.warn('⚠️ Purchase Records API Failed:', err)
            return { data: { success: true, data: [] } }
          })
      ])

      const sales = Array.isArray(salesRes.data?.data) ? salesRes.data.data : []
      const purchases = Array.isArray(purchaseRes.data?.data) ? purchaseRes.data.data : []
      const purchaseRecords = Array.isArray(purchaseRecordsRes.data?.data) ? purchaseRecordsRes.data.data : (Array.isArray(purchaseRecordsRes.data) ? purchaseRecordsRes.data : [])

      console.log('📦 Raw Sales:', sales)
      console.log('📦 Raw Purchases:', purchases)
      console.log('📦 Raw Purchase Records:', purchaseRecords)

      const normalizedSales = sales.map(s => ({
        ...s,
        type: 'sale',
        secondPartyName: s.buyer_name,
        amount: s.sale_amount,
        vehicle: {
          regNumber: s.vehicle_number,
          make: s.brand,
          model: s.model,
          year: s.model_year,
          dateTime: s.date_time
        }
      }))

      const normalizedPurchases = purchases.map(p => {
        // Find matching purchase record to get the registration number (vehicle_number)
        const record = purchaseRecords.find(r => String(r.id) === String(p.purchase_record_id))
        
        return {
          ...p,
          type: 'purchase',
          secondPartyName: p.party1_name || p.seller_name,
          seller_phone: record?.seller_phone || p.party1_phone || '',
          amount: p.sale_amount || p.purchase_amount,
          vehicle: {
            regNumber: p.vehicle_number || record?.vehicle_number || '',
            make: p.brand || record?.brand || '',
            model: p.model || record?.model || '',
            year: p.model_year || record?.model_year || '',
            dateTime: p.date_time || record?.purchase_date || p.createdAt
          }
        }
      })

      const all = [...normalizedSales, ...normalizedPurchases].sort((a, b) => {
        return new Date(b.date_time || b.createdAt) - new Date(a.date_time || a.createdAt)
      })

      commit('SET_ITEMS', all)
      commit('RECOMPUTE')

      console.log('✅ [listAgreements] SUCCESS')
      return all
    } catch (err) {
      console.error('❌ [listAgreements] ERROR:', err)
      commit('SET_ERROR', 'Failed to load agreements')
      return []
    } finally {
      commit('SET_LOADING', false)
      console.log('🏁 [listAgreements] END')
    }
  },

  async removeAgreement({ commit }, id) {
    console.log('🗑️ Removing Agreement ID:', id)

    try {
      const results = await Promise.allSettled([
        api.delete(`agreements/${id}`),
        api.delete(`purchase-agreements/${id}`)
      ])

      console.log('📡 Delete Results:', results)

      commit('REMOVE_ITEM', id)
      commit('RECOMPUTE')
    } catch (err) {
      console.error('❌ [removeAgreement] ERROR:', err)
      throw err
    }
  },

  createAgreement({ commit }, data) {
    console.log('➕ Creating Agreement:', data)

    const id = `AG-${Date.now()}`
    const item = { id, ...data }

    commit('ADD_ITEM', item)
    commit('RECOMPUTE')

    return item
  },

  getAgreement({ state }, id) {
    console.log('🔍 Get Agreement ID:', id)
    const item = state.items.find(a => String(a.id) === String(id))
    console.log('📄 Found Item:', item)
    return item
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}